<template>
  <div class="home">
    <login />
  </div>
</template>

<script>
// @ is an alias to /src
import login from '@/components/auth/login.vue'

export default {
  name: 'Home',
  components: {
    login
  }
}
</script>

<style>
.home {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 30px;
}
</style>